import React from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { HummingbirdLogo, HummingbirdLogoText } from '../../atoms';
import Colours from '../../tokens/colours';
import MediaQueries from '../../tokens/MediaQueries';
import { EXPANDED_DESKTOP_WIDTH } from './constants';
const getStyles = createUseStyles({
    root: {
        display: 'none',
        [MediaQueries.medium]: {
            display: 'flex',
            alignItems: 'center',
            position: 'absolute',
            paddingLeft: 8,
            bottom: 0,
            height: 63,
            backgroundColor: Colours.white,
            borderTop: `1px ${Colours.quarternary} solid`,
        },
        [MediaQueries.large]: {
            width: EXPANDED_DESKTOP_WIDTH,
        },
    },
    logo: {
        height: 32,
    },
    logoText: {
        marginLeft: 8,
        height: 24,
        opacity: 0,
        transition: 'opacity 0.3s',
    },
    logoTextReveal: {
        [MediaQueries.large]: {
            opacity: 1,
        },
    },
});
const LogoWrapper = ({ isExpanded }) => {
    const styles = getStyles();
    return (React.createElement("div", { className: styles.root },
        React.createElement(HummingbirdLogo, { className: styles.logo }),
        React.createElement(HummingbirdLogoText, { className: classNames(styles.logoText, {
                [styles.logoTextReveal]: isExpanded,
            }) })));
};
export default LogoWrapper;
//# sourceMappingURL=LogoWrapper.js.map